import React, { createContext, useState, useContext } from "react";

// Booking context
const BookingContext = createContext();

// Initial state based on your NewBookingRequest
const initialBookingState = {
  from: null,
  to: null,
  dateString: "",
  expectedNumberOfChildren: null,
  expectedNumberOfAdults: null,
  packageId: "",
  playroomId: "",
  status: "PENDING",
  customerFirstName: "",
  customerLastName: "",
  customerEmail: "",
  customerPhoneNumber: "",
  specialOffersId: [],
  note: "",
  paymentMethod: "",
  childName: "",
  food: "",
};

export const BookingProvider = ({ children }) => {
  const [bookingState, setBookingState] = useState(initialBookingState);

  const updateBooking = (field, value) => {
    setBookingState((prevState) => ({
      ...prevState,
      [field]: value,
    }));
  };

  return (
    <BookingContext.Provider value={{ bookingState, updateBooking }}>
      {children}
    </BookingContext.Provider>
  );
};

// Step 3: Custom Hook to use Booking Context
export const useBooking = () => useContext(BookingContext);
